const baseRoutes = Object.freeze({
    root: '/',
    login: '/login',
    landing: '/landing',
    settings: '/settings',
    mediaOrders: '/media-orders',
    mediaOrdersItem: '/media-orders/:id',
    contentItems: '/content-items-search',
    contentItemsItem: '/content-items-search/:id',
    contentItemsSearch: '/content-items-search',
    videoAudioQc: '/video-audio-qc/:id',
    qcManager: '/qc-manager',
    qcJobs: '/qc-work-queue',
    ingest: '/ingest-list',
    search: '/search',
    ingestReport: '/ingest-list/validation/:id',
    ingestData: '/ingest-sessions',
    ingestDataItem: '/ingest-list/sessions/:id',
    ingestDataItemError: '/ingest-list/error-session/:id',
    qcJobsTools: '/qc-work-queue/:id',
    qcManagerTools: '/qc-manager/:id',
    deliveryManager: '/delivery-manager',
    deliveryManagerManifest: '/delivery-manager/manifest/:id',
});

const adminRoutes = Object.freeze({
    ingestConfigs: '/ingest-configs',
    newIngestFeed: '/ingest-configs-new',
    editIngestFeed: '/ingest-configs-edit/:id',
    contentPartners: '/content-partners',
    newContentPartner: '/content-partners-new',
    editContentPartner: '/content-partners-edit/:id',
    users: '/users',
    addUser: '/users/add',
    userDetails: '/users/:id',
    roles: '/roles',
});

export {
adminRoutes, baseRoutes
};
